import { render, staticRenderFns } from "./ViewCameraPlusBack.vue?vue&type=template&id=e53ea4b8&scoped=true&"
import script from "./ViewCameraPlusBack.vue?vue&type=script&lang=js&"
export * from "./ViewCameraPlusBack.vue?vue&type=script&lang=js&"
import style0 from "./ViewCameraPlusBack.vue?vue&type=style&index=0&id=e53ea4b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53ea4b8",
  null
  
)

export default component.exports